import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// The JWT is stored ONLY in an httpOnly cookie set by the backend
// (see /api/auth/login and /api/auth/register). We keep an in-memory
// mirror for the current tab so streaming/fetch calls that can't rely
// on credentialed requests (e.g. some third-party proxies) still work.
// It is NEVER persisted to localStorage/sessionStorage — XSS-safe.
let _memToken = null;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  if (_memToken) config.headers.Authorization = `Bearer ${_memToken}`;
  return config;
});

export function saveToken(t) { _memToken = t || null; }
export function clearToken() { _memToken = null; }
export function getToken() { return _memToken; }
